import Reveal from "@/components/base/Reveal";
import Eyebrow from "@/components/base/Eyebrow";
import { about, values } from "@/mocks/site";

const valueBars = ["bar-gold", "bar-rose", "bar-clinic"];

export default function StorySection() {
  return (
    <section id="nosotros" className="relative overflow-hidden bg-background-50">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px line-gold" />
      <div className="pointer-events-none absolute -right-24 top-16 h-[360px] w-[360px] rounded-full glow-rose blur-3xl" />
      <div className="pointer-events-none absolute -left-24 bottom-10 h-[320px] w-[320px] rounded-full glow-lilac blur-3xl" />
      <div className="relative mx-auto w-full max-w-[1400px] px-5 py-20 md:px-10 md:py-28">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:items-center lg:gap-16">
          <Reveal className="lg:col-span-6">
            <Eyebrow>{about.eyebrow}</Eyebrow>
            <h2 className="mt-4 font-heading text-4xl font-bold leading-[1.05] text-foreground-950 md:text-5xl">
              {about.title}
            </h2>
            <p className="mt-5 max-w-xl font-heading text-xl leading-relaxed text-foreground-800 md:text-2xl">
              {about.lead}
            </p>
            <div className="mt-4 space-y-3">
              {about.paragraphs.map((paragraph) => (
                <p key={paragraph} className="max-w-xl text-[15px] leading-relaxed text-foreground-600">
                  {paragraph}
                </p>
              ))}
            </div>

            <dl className="mt-8 grid grid-cols-3 gap-5 border-t border-secondary-200 pt-7">
              {about.stats.map((stat) => (
                <div key={stat.label}>
                  <dt className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
                    {stat.value}
                  </dt>
                  <dd className="mt-1.5 text-xs leading-snug text-foreground-500 md:text-sm">
                    {stat.label}
                  </dd>
                </div>
              ))}
            </dl>
          </Reveal>

          <Reveal delay={120} className="lg:col-span-6">
            <div className="relative">
              <div className="pointer-events-none absolute -inset-6 glow-clinic" />
              <div className="pointer-events-none absolute -right-4 -top-4 h-20 w-20 rounded-tr-[28px] border-r border-t border-accent-400/60" />
              <div className="card-premium relative h-[340px] w-full overflow-hidden rounded-[28px] bg-background-100 md:h-[520px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Bright%20clean%20modern%20interior%20of%20a%20minimal%20aesthetic%20clinic%20with%20white%20walls%2C%20warm%20wood%20accents%20and%20a%20treatment%20bed%20with%20fresh%20white%20linen%2C%20soft%20natural%20daylight%2C%20airy%20hygienic%20atmosphere%2C%20no%20text&width=1000&height=1200&seq=aleaW-story&orientation=portrait&nocache=true"
                  alt="Interior de la clínica estética premium ALÉA Aesthetic House"
                  title="Historia de ALÉA Aesthetic House Culiacán"
                  className="h-full w-full object-cover object-top"
                />
                <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-primary-950/25 to-transparent" />
              </div>
            </div>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-3">
          {values.map((value, index) => (
            <Reveal
              key={value.title}
              delay={index * 90}
              className="card-soft group relative flex flex-col overflow-hidden rounded-[24px] border border-secondary-200 bg-background-50 p-7 transition-all duration-500 hover:-translate-y-1 hover:card-premium"
            >
              <span className={`absolute inset-x-0 top-0 h-[3px] ${valueBars[index % valueBars.length]}`} />
              <span className="flex h-12 w-12 items-center justify-center rounded-[14px] border border-accent-200 bg-accent-50 text-accent-700">
                <i className={`${value.icon} text-xl`} />
              </span>
              <h3 className="mt-5 font-heading text-lg font-bold leading-snug text-foreground-950">
                {value.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{value.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}